/**
 * Track via Meta, etc.
 * Meta: https://developers.facebook.com/docs/meta-pixel/reference#standard-events
 */

import { nanoid } from "nanoid"
import type { ConversionSchema } from "@/core/interfaces/analytics"
import { isDebug } from "@/lib/env"

const storageKey = "conversion"
const url = "/api/v1/track"

type AnalyticsEvent = "Contact" | "FindLocation" | "Lead" | "ViewContent" | string
export async function track(event: AnalyticsEvent, properties: Record<string, any> = {}) {
  const props = {
    ...properties,
    event_id: nanoid(),
  }
  const conversion = {
    ua: window.navigator.userAgent,
    ...JSON.parse(localStorage.getItem(storageKey) || "{}"),
    path: location.pathname,
    language: navigator.language,
    tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
    referer: document.referrer,
  }

  /**
   * Prepare Beacon Data
   */
  const data = new FormData()
  data.append(
    "track",
    JSON.stringify({
      event,
      properties: props,
      conversion,
    }),
  )
  if (!isDebug) {
    gtag("event", event, props)
    fbq("trackCustom", event, props)
    navigator.sendBeacon(url, data)
  } else {
    console.log(`track`, { event, props })
  }
}

export async function retrieveAdsParams() {
  let conversion: ConversionSchema = JSON.parse(localStorage.getItem(storageKey) || "{}")
  const searchParams = new URLSearchParams(location.search)
  if (JSON.stringify(conversion) === "{}" || conversion.lastUpdated! < new Date().getTime() - 1000 * 60 * 60) {
    conversion = {
      utm: {
        campaign: searchParams.get("utm_campaign") || "",
        source: searchParams.get("utm_source") || "",
        medium: searchParams.get("utm_medium") || "",
        term: searchParams.get("utm_term") || "",
        content: searchParams.get("utm_content") || "",
        content_id: searchParams.get("utm_content_id") || "",
      },
      lastUpdated: new Date().getTime(),
    }
    if (searchParams.get("fbclid") || searchParams.get("fbc")) {
      conversion.meta = {
        fbclid: searchParams.get("fbclid") || "",
        fbc: searchParams.get("fbc") || "",
      }
    }
    if (searchParams.get("gclid") || searchParams.get("gbraid")) {
      conversion.google = {
        gclid: searchParams.get("gclid") || "",
        gbraid: searchParams.get("gbraid") || "",
      }
    }
    let success = false
    while (!success) {
      try {
        const { origin: ip } = (await (await fetch(`http://httpbin.org/ip`)).json()) as {
          origin: string
        }
        conversion.ip = ip
        success = true
      } catch {
        console.log(`Error getting IP, trying..`)
      }
    }
    localStorage.setItem(storageKey, JSON.stringify(conversion))
  }
}
